import { HttpClient } from './http-client';
import {
    EmployeeAuthService,
    AdminAuthService,
} from '@/modules/auth/features/employee-auth/services';

export const employeeHttp = new HttpClient(EmployeeAuthService);
export const adminHttp = new HttpClient(AdminAuthService);
